import { matchPath, useLocation } from 'react-router-dom'
import { getConfig } from 'src/helpers'

const { isEudora } = getConfig()

export const useNeutralLink = () => {
  const location = useLocation()
  let neutralLink: string | undefined = '/catalogodigital'

  let routeMatch = matchPath(neutralLink, location.pathname)

  if (isEudora && routeMatch == null) {
    neutralLink = '/guiadigital'
    routeMatch = matchPath(neutralLink, location.pathname)
  }

  const isNeutralLink = Boolean(routeMatch)

  return { isNeutralLink, neutralLink }
}
